import script from "./WelcomeBoxContent.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeBoxContent.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeBoxContent.vue?vue&type=style&index=0&id=6a3a3507&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3a3507"]])

export default __exports__